export default __webpack_public_path__ + "static/media/revive-leaf.76630b10.svg";